import AoneService from "../axiosbase";

export const deleteThirdparty = async (params) => {
  try {
    return await AoneService.delete("third-party/api/v1/third-party/" + params);
  } catch (error) {
    return error;
  }
};

//paymenttype lookup
export const getPaymentThirdparty = async () => {
  try {
    return await AoneService.get("third-party/api/v1/lookup/PaymentType");
  } catch (error) {
    return error;
  }
};

export const deleteMapping = async (params) => {
  try {
    return await AoneService.delete("third-party/api/v1/mappings/" + params);
  } catch (error) {
    return error;
  }
};

//get third party
export const getThirdparty = async (params) => {
  try {
    return await AoneService.get("third-party/api/v1/third-party" + params);
  } catch (error) {
    return error;
  }
};

//get mappings-thirdparty
export const getMapping = async (params) => {
  try {
    return await AoneService.get("third-party/api/v1/mappings" + params);
  } catch (error) {
    return error;
  }
};

//get mapping types
export const getMappingTypes = async () => {
  try {
    return await AoneService.get("third-party/api/v1/lookup/MappingType");
  } catch (error) {
    return error;
  }
};

//thirdparty type
export const getThirdpartyType = async () => {
  try {
    return await AoneService.get("third-party/api/v1/lookup/ThirdPartyType");
  } catch (error) {
    return error;
  }
};

//create third party
export const postThirdParty = async (data) => {
  try {
    return await AoneService.post("third-party/api/v1/third-party/", data);
  } catch (error) {
    return error;
  }
};

//edit third party
export const EditThirdparty = async (params, data) => {
  try {
    return await AoneService.put(
      "third-party/api/v1/third-party/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//mapping
export const postMapping = async (data) => {
  try {
    return await AoneService.post("third-party/api/v1/mappings/", data);
  } catch (error) {
    return error;
  }
};

//edit mapping
export const EditMapping = async (params, data) => {
  try {
    return await AoneService.patch(
      "third-party/api/v1/mappings/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//payment type lookup
export const getPaymentsType = async () => {
  try {
    return await AoneService.get(`third-party/api/v1/lookups/PaymentType`);
  } catch (error) {
    return error;
  }
};

//get events
export const getEvents = async (params) => {
  try {
    return await AoneService.get("third-party/api/v1/scans" + params);
  } catch (error) {
    return error;
  }
};

export const exportEvents = async (params) => {
  try {
    return await AoneService.get("third-party/api/v1/scans/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//get orders
export const getOrders = async (params) => {
  try {
    return await AoneService.get("third-party/api/v1/orders" + params);
  } catch (error) {
    return error;
  }
};

//assign orders
export const assignOrders = async (data) => {
  try {
    return await AoneService.post("third-party/api/v1/orders/assign", data);
  } catch (error) {
    return error;
  }
};

export const assignBulkOrders = async (data) => {
  try {
    return await AoneService.post("third-party/api/v1/orders/bulk-assign", data);
  } catch (error) {
    return error;
  }
};

//cancel orders
export const cancelOrders = async (data) => {
  try {
    return await AoneService.post("third-party/api/v1/orders/cancel", data);
  } catch (error) {
    return error;
  }
};

//print orders
export const printOrders = async (params,params2) => {
  try {
    return await AoneService.get(`third-party/api/v1/orders/${params}/print/${params2}`);
  } catch (error) {
    return error;
  }
};
